<div class="accreditation-page">

    <div class="page-header">
      <div>
        <h1>Acreditaciones</h1>
        <p>
          Consulta y gestiona las horas de Servicio Social acreditadas.
        </p>
      </div>
  
      <div class="total-badge">
        {{ pendingAccreditations.length }}
        <span>pendientes</span>
      </div>
    </div>

    <div class="accreditation-tabs">

        <button
          type="button"
          class="accreditation-tab"
          [class.active]="!showHistory"
          (click)="toggleAccreditationsView(false)"
        >
          <span>Pendientes</span>
          <span class="tab-count">
            {{ pendingAccreditations.length }}
          </span>
        </button>
      
        <button
          type="button"
          class="accreditation-tab"
          [class.active]="showHistory"
          (click)="toggleAccreditationsView(true)"
        >
          <span>Historial</span>
          <span class="tab-count">
            {{ historyAccreditations.length }}
          </span>
        </button>
      
      </div>

    <!-- BÚSQUEDA POR FOLIO DE INTERACCIÓN (Fase C2.1) -->
    <div class="folio-search-bar">
      <label for="accreditation-folio-search">
        Buscar por folio de interacción
      </label>
      <input
        id="accreditation-folio-search"
        type="text"
        class="folio-search-input"
        [(ngModel)]="folioSearch"
        (ngModelChange)="onFolioSearchChange()"
        placeholder="Ej. AC-251103-00001"
      />
    </div>

    @if (successMessage) {
        <div class="success-message">
          {{ successMessage }}
        </div>
      }
  
    @if (isLoading) {
  
      <div class="loading-state">
        <p>Cargando acreditaciones...</p>
      </div>
  
    } @else if (currentAccreditations.length === 0) {

        <div class="empty-state">
      
          <div class="empty-icon">
            {{ showHistory ? '📁' : '📋' }}
          </div>
      
          @if (showHistory) {
      
            <h2>No hay acreditaciones en el historial</h2>
      
            <p>
              Todavía no hay acreditaciones aprobadas o rechazadas.
            </p>
      
          } @else {
      
            <h2>No hay acreditaciones pendientes</h2>
      
            <p>
              No hay solicitudes de acreditación pendientes por gestionar.
            </p>
      
          }
      
        </div>
      
      } @else {
  
      <div class="accreditation-list">
  
        @for (
        accreditation of currentAccreditations;
        track accreditation._id
        ) {
  
  <article
  class="accreditation-card"
  [class.history-card]="showHistory"
>

    <div class="accreditation-header">
  
      <div>
        <span class="accreditation-type">
          @switch (accreditation.type) {
            @case ('EVENT') { Evento ABAQ }
            @case ('INDUCTION') { Inducción }
            @case ('IDENTIFICATION') { Placas de identificación }
            @case ('STERILIZATION') { Esterilización }
            @case ('ADOPTION') { Adopción }
            @case ('ADOPTION_MODULE') { Módulo de adopción }
            @case ('TALK') { Plática ABAQ }
            @case ('CAMPAIGN') { Campaña }
            @case ('MEDIA') { Difusión en medios }
            @case ('SOCIAL_MEDIA') { Redes sociales }
            @case ('DONATION') { Recaudación de fondos }
            @case ('ADMINISTRATIVE') { Actividad administrativa }
            @default { {{ accreditation.type }} }
          }
        </span>
  
        <h2>
          {{ accreditation.date | date:'mediumDate':'UTC' }}
        </h2>

        @if (accreditation.interactionFolio) {
          <div class="accreditation-folio-row">
            <app-folio-pill
              [folio]="accreditation.interactionFolio"
              [interactionType]="accreditation.interactionType || 'AC'"
              [showHours]="true"
              [hours]="accreditation.hoursAccredited || 0"
            ></app-folio-pill>
          </div>
        }
      </div>
  
      <span
        class="status-badge"
        [class.status-approved]="accreditation.status === 'approved'"
        [class.status-pending]="accreditation.status === 'pending'"
        [class.status-rejected]="accreditation.status === 'rejected'"
      >
        @switch (accreditation.status) {
          @case ('approved') { Aprobada }
          @case ('pending') { Pendiente }
          @case ('rejected') { Rechazada }
          @default { {{ accreditation.status }} }
        }
      </span>
  
    </div>
  
  
    <div class="student-info">
  
      <div class="student-avatar">
        {{ accreditation.studentRef?.nombreCompleto?.charAt(0) || '?' }}
      </div>
  
      <div>
        <h3>
          {{ accreditation.studentRef?.nombreCompleto || 'Sin estudiante' }}
        </h3>
  
        <p>
          Matrícula:
          {{ accreditation.studentRef?.matricula || 'Sin registrar' }}
        </p>
      </div>
  
    </div>
  
  
    <div class="hours-summary">
  
      <div class="hours-card accredited">
        <span>Horas acreditadas</span>
  
        <strong>
          {{ accreditation.hoursAccredited || 0 }} h
        </strong>
      </div>
  
      <div class="hours-card performed">
        <span>Horas realizadas</span>
  
        <strong>
          {{ accreditation.hoursPerformed || 0 }} h
        </strong>
      </div>
  
    </div>
  
  
    <button
      type="button"
      class="details-button"
      (click)="toggleAccreditationDetails(accreditation)"
    >
      {{
        expandedAccreditationId === accreditation._id
          ? 'Ocultar detalle'
          : 'Ver detalles'
      }}
    </button>
  
  
    @if (expandedAccreditationId === accreditation._id) {
  
      <div class="accreditation-details">
  
        @if (accreditation.type === 'EVENT') {
  
          <p>
            <strong>Tipo de evento:</strong>
            {{
              accreditation.eventType === 'SHELTER_CLEANING'
                ? 'Limpieza de refugio'
                : 'Evento general'
            }}
          </p>
  
          <p>
            <strong>Horas realizadas:</strong>
            {{ accreditation.hoursPerformed || 0 }} h
          </p>
  
          <p>
            <strong>Factor de acreditación:</strong>
            {{
              accreditation.eventType === 'SHELTER_CLEANING'
                ? '4×'
                : '2×'
            }}
          </p>
  
          <p>
            <strong>Horas acreditadas:</strong>
            {{ accreditation.hoursAccredited || 0 }} h
          </p>
  
        } @else {
            <p>
              <strong>Tipo:</strong>
          
              @switch (accreditation.type) {
                @case ('EVENT') {
                  Evento ABAQ
                }
          
                @case ('INDUCTION') {
                  Inducción
                }
          
                @case ('IDENTIFICATION') {
                  Placas de identificación
                }
          
                @case ('STERILIZATION') {
                  Esterilización
                }
          
                @case ('ADOPTION') {
                  Adopción
                }
          
                @case ('ADOPTION_MODULE') {
                  Módulo de adopción
                }
          
                @case ('TALK') {
                  Plática ABAQ
                }
          
                @case ('CAMPAIGN') {
                  Campaña
                }
          
                @case ('MEDIA') {
                  Difusión en medios
                }
          
                @case ('SOCIAL_MEDIA') {
                  Redes sociales
                }
          
                @case ('DONATION') {
                  Recaudación de fondos
                }
          
                @case ('ADMINISTRATIVE') {
                  Actividad administrativa
                }
          
                @default {
                  Actividad de Servicio Social
                }
              }
            </p>
  
          @if (accreditation.quantity) {
            <p>
              <strong>Cantidad:</strong>
              {{ accreditation.quantity }}
            </p>
          }
  
          @if (accreditation.participantsCount) {
            <p>
              <strong>Participantes:</strong>
              {{ accreditation.participantsCount }}
            </p>
          }
  
          @if (accreditation.animalsEnrolled) {
            <p>
              <strong>Animales registrados:</strong>
              {{ accreditation.animalsEnrolled }}
            </p>
          }
  
          @if (accreditation.comments) {
            <p>
              <strong>Comentarios:</strong>
              {{ accreditation.comments }}
            </p>
          }
  
          <p>
            <strong>Horas acreditadas:</strong>
            {{ accreditation.hoursAccredited || 0 }} h
          </p>
  
        }
  
      </div>
  
    }
  
  
    @if (accreditation.status === 'pending') {
  
      <div class="accreditation-actions">
  
        <button
          type="button"
          class="reject-button"
          [disabled]="processingId === accreditation._id"
          (click)="rejectAccreditation(accreditation)"
        >
          Rechazar acreditación
        </button>
  
        <button
          type="button"
          class="approve-button"
          [disabled]="processingId === accreditation._id"
          (click)="approveAccreditation(accreditation)"
        >
          Aprobar acreditación
        </button>
  
        <button
          type="button"
          class="manual-hours-button"
          [disabled]="processingId === accreditation._id"
          (click)="openManualHoursModal(accreditation)"
        >
          Asignar horas manualmente
        </button>
  
      </div>
  
    }
  
  </article>
  
        }
  
      </div>

      @if (accreditationsTotalPages > 1) {
        <div class="pagination">
          <button
            type="button"
            class="pagination-button"
            (click)="previousAccreditationsPage()"
            [disabled]="accreditationsPage === 1"
          >
            ←
          </button>
      
          @for (page of accreditationsPages; track page) {
            <button
              type="button"
              class="pagination-button"
              [class.active]="accreditationsPage === page"
              (click)="goToAccreditationsPage(page)"
            >
              {{ page }}
            </button>
          }
      
          <button
            type="button"
            class="pagination-button"
            (click)="nextAccreditationsPage()"
            [disabled]="accreditationsPage === accreditationsTotalPages"
          >
            →
          </button>
        </div>
      }
  
    }

  
    @if (showManualHoursModal && selectedAccreditation) {

        <div class="modal-overlay">
      
          <div class="manual-hours-modal">
      
            <div class="modal-header">
      
              <div>
                <span class="modal-eyebrow">
                  Acreditación manual
                </span>
      
                <h2>Asignar horas manualmente</h2>
      
                <p>
                  Define cuántas horas deseas acreditar a este estudiante.
                </p>
              </div>
      
              <button
                type="button"
                class="modal-close-button"
                (click)="closeManualHoursModal()"
              >
                ×
              </button>
      
            </div>
      
      
            <div class="modal-student">
      
              <div class="modal-student-avatar">
                {{
                  selectedAccreditation.studentRef?.nombreCompleto?.charAt(0) || '?'
                }}
              </div>
      
              <div>
                <strong>
                  {{
                    selectedAccreditation.studentRef?.nombreCompleto
                    || 'Sin estudiante'
                  }}
                </strong>
      
                <span>
                  Matrícula:
                  {{
                    selectedAccreditation.studentRef?.matricula
                    || 'Sin registrar'
                  }}
                </span>
              </div>
      
            </div>
      
      
            <div class="manual-hours-field">
      
              <label for="manualHours">
                Horas a acreditar
              </label>
      
              <input
                id="manualHours"
                type="number"
                min="0.1"
                step="0.5"
                [(ngModel)]="manualHours"
                placeholder="Ej. 5"
              />
      
              <small>
                Puedes asignar una cantidad diferente a las horas calculadas
                originalmente.
              </small>
      
            </div>
      
      
            <div class="modal-actions">
      
              <button
                type="button"
                class="modal-cancel-button"
                (click)="closeManualHoursModal()"
              >
                Cancelar
              </button>
      
              <button
                type="button"
                class="modal-confirm-button"
                [disabled]="manualHours === null || manualHours <= 0"
                (click)="assignManualHours()"
              >
                Asignar {{ manualHours || 0 }} h
              </button>
      
            </div>
      
          </div>
      
        </div>
      
      }
</div>